import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-merge-cells-vertical",
  "use": "icon-merge-cells-vertical-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-merge-cells-vertical\">\n    <g>\n        <path fill=\"none\" d=\"M0 0H24V24H0z\" />\n        <path d=\"M21 20c0 .552-.448 1-1 1H4c-.552 0-1-.448-1-1V4c0-.552.448-1 1-1h16c.552 0 1 .448 1 1v16zm-2-9V5h-5.999v2H15l-3 3-3-3h2V5H5v6h2v2H5v6h6v-2H9l3-3 3 3h-1.999v2H19v-6h-2v-2h2zm-8 2H9v-2h2v2zm4 0h-2v-2h2v2z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol